import { render } from "./CardSelect.vue?vue&type=template&id=270b3bc1&scoped=true"
import script from "./CardSelect.vue?vue&type=script&lang=js"
export * from "./CardSelect.vue?vue&type=script&lang=js"

import "./CardSelect.vue?vue&type=style&index=0&id=270b3bc1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270b3bc1"]])

export default __exports__